import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectExternalCost } from "../Model/ProposalProjectExternalCost";

export async function createProposalProjectExternalCost(data) {
	let response = await getAPIResponse("/v1/proposal-project-external-cost/add", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProjectExternalCost = [];
	response.forEach((element) => {
		proposalProjectExternalCost.push(ProposalProjectExternalCost.createFromResponseData(element));
	});
	return proposalProjectExternalCost;
}
